import React from 'react';
import { User } from 'lucide-react';
import { SideDrawer, ProgressBar } from './SideDrawer';
import { StatusPill, fmtDT } from './ReportTableKit';

export default function LearnerJourneyDrawer({ learner, journeyName, pii, onClose }) {
  const title = pii ? (learner.learner_name || `Learner ${learner.student_user_id}`) : `Learner ${learner.student_user_id}`;
  const p = learner.progress || {};
  return (
    <SideDrawer testId="learner-journey-drawer" icon={User} kicker="Journey progress" title={title}
      subtitle={[pii ? learner.email : null, learner.partner_name, journeyName].filter(Boolean).join(' · ')} onClose={onClose}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0,1fr))', gap: 10, marginBottom: 18 }}>
        {[['Status', <StatusPill status={learner.status} />], ['Enrolled', fmtDT(learner.enrolled_date)],
          ['Completed', fmtDT(learner.completed_date)], ['Last activity', fmtDT(learner.last_activity_date)]].map(([k, v]) => (
          <div key={k} style={{ border: '1px solid #e2e8f0', borderRadius: 8, padding: 10 }}>
            <div style={{ fontSize: 11, color: '#64748b', fontWeight: 600, textTransform: 'uppercase' }}>{k}</div>
            <div style={{ fontSize: 13, fontWeight: 600, marginTop: 4 }}>{v}</div>
          </div>
        ))}
      </div>
      <div style={{ marginBottom: 20 }} data-testid="learner-journey-overall">
        <div style={{ fontSize: 12, color: '#475569', marginBottom: 4 }}>Overall: {p.required_completed ?? 0} of {p.required_total ?? 0} required activities</div>
        <ProgressBar pct={p.progress_pct} />
      </div>
      {(learner.phases || []).map(ph => (
        <div key={ph.id} data-testid={`learner-journey-phase-${ph.id}`} style={{ marginBottom: 16, border: '1px solid #e2e8f0', borderRadius: 10 }}>
          <div style={{ padding: '10px 14px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ fontSize: 14, fontWeight: 700, flex: 1 }}>{ph.name}
              <span style={{ fontSize: 12, fontWeight: 500, color: '#64748b' }}> · {ph.required_completed ?? 0}/{ph.required_total ?? 0} required</span>
            </div>
            <div style={{ width: 180 }}><ProgressBar pct={ph.progress_pct} /></div>
          </div>
          {(ph.activities || []).map((a, i) => (
            <div key={a.id} data-testid={`learner-journey-activity-${a.id}`} style={{ padding: '8px 14px', borderTop: i ? '1px solid #f1f5f9' : 'none', display: 'flex', gap: 12, alignItems: 'center' }}>
              <div style={{ flex: 1, minWidth: 0, fontSize: 13 }}>
                {a.name}
                <span style={{ fontSize: 11, color: '#94a3b8' }}> · {a.type || '—'}{a.is_required ? '' : ' · optional'}</span>
              </div>
              <span style={{ fontSize: 12, color: '#64748b', whiteSpace: 'nowrap' }}>{fmtDT(a.date)}</span>
              <StatusPill status={a.status} />
            </div>
          ))}
        </div>
      ))}
    </SideDrawer>
  );
}
